// components/StatCard.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { colorMap } from '../constants';
import { Card } from './ui';
import { getIntlLocale } from '../utils';

export const StatCard = ({ title, value, subtext, icon: Icon, color = "indigo" }) => {
  const { i18n } = useTranslation();
  const styles = colorMap[color] || colorMap.indigo;
  const displayValue = typeof value === 'number' ? value.toLocaleString(getIntlLocale(i18n.language)) : value;
  const valueLength = String(displayValue).length;
  // Автоподбор размера — большие числа (тысячи алертов) не должны обрезаться
  // внутри карточки (у Card стоит overflow-hidden).
  const valueSizeClass =
    valueLength > 8 ? 'text-xl' :
    valueLength > 6 ? 'text-2xl' :
    valueLength > 4 ? 'text-3xl' :
    'text-4xl';
  return (
    <Card hover className="shadow-xl group">
      <div className={`absolute -right-6 -bottom-6 opacity-5 ${styles.text} group-hover:scale-110 transition-transform duration-500`}>
        <Icon size={140} />
      </div>
      <div className="flex justify-between items-start mb-4 relative z-10">
        <div className={`p-4 rounded-2xl ${styles.bg} ${styles.text} ${styles.hover} group-hover:text-gray-900 transition-all duration-300`}>
          <Icon size={24} />
        </div>
      </div>
      <div className="relative z-10 min-w-0">
        <h3 className={`${valueSizeClass} font-black text-gray-900 mb-1 tracking-tight truncate`} title={String(displayValue)}>{displayValue}</h3>
        <p className="text-caption font-black text-gray-400 uppercase tracking-[0.2em]">{title}</p>
        <p className="text-caption text-gray-500 mt-2 font-medium italic leading-relaxed">{subtext}</p>
      </div>
    </Card>
  );
};
